const CART_DRAWER_ADDON_GROUPS = [
  {
    enabledKey: "servicesEnabled",
    group: "services",
    legacyTitles: ["Professional Installation", "Haul-away & Recycle"],
  },
  {
    enabledKey: "warrantyEnabled",
    group: "warranty",
    legacyTitles: ["Extend your Warranty"],
  },
];

const CART_DRAWER_ADDON_BOUNDARY_SELECTOR =
  ".cart-addons-list__header, [data-cart-drawer-addon-group]";

const CART_DRAWER_ADDON_TITLE_SELECTOR = ".cart-addons-list__header-title";
const CART_DRAWER_MAX_DISCOUNT_BADGES = 2;
const CART_DRAWER_DISCOUNT_BADGE_CLASS = "cart-drawer__discount-badge";
const CART_DRAWER_STYLED_DISCOUNT_BADGE_CLASS =
  "cart-drawer__discount-badge--styled";
const CART_DRAWER_OVERRIDE_DISCOUNT_BADGE_CLASS =
  "cart-drawer__discount-badge--override";

const removeDrawerAddonHeaderSection = (titleElement) => {
  let element = titleElement.closest(".cart-addons-list__header");

  while (element) {
    const nextElement = element.nextElementSibling;
    element.remove();

    if (
      !nextElement ||
      nextElement.matches(CART_DRAWER_ADDON_BOUNDARY_SELECTOR)
    ) {
      return;
    }

    element = nextElement;
  }
};

class CustomCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector("#cart-drawer-content");
    this.closeButtons = this.querySelectorAll("[data-close]");
    this.overlay = document.getElementById("cart-drawer-overlay");

    this.itemWrapper = this.querySelector("#cart-drawer-item-wrapper");
    this.itemImage = this.querySelector("#cart-drawer-item-image");
    this.itemTitle = this.querySelector("#cart-drawer-item-title");
    this.itemVariantWrapper = this.querySelector("#cart-drawer-item-variant");
    this.itemVariantText = this.itemVariantWrapper
      ? this.itemVariantWrapper.querySelector(".condition-badge__text")
      : null;
    this.itemPrice = this.querySelector("#cart-drawer-item-price");
    this.itemCompareAtPrice = this.querySelector(
      "#cart-drawer-item-compare-at-price",
    );
    this.itemSave = this.querySelector("#cart-drawer-item-save");
    this.itemDiscountBadges = this.querySelector(
      "[data-cart-item-discount-badges]",
    );
    this.discountBadgeDefaultIconTemplate = this.querySelector(
      "[data-cart-drawer-discount-badge-default-icon-template]",
    );
    this.discountBadgeOverrideIconTemplate = this.querySelector(
      "[data-cart-drawer-discount-badge-override-icon-template]",
    );
    this.discountBadgeMatchText = (
      this.dataset.cartDiscountBadgeMatchText || ""
    )
      .trim()
      .toLowerCase();
    this.itemShippingMessage = this.querySelector(
      "#cart-drawer-shipping-message",
    );
    this.itemWarrantyBenefit = this.querySelector(
      "[data-cart-item-warranty-benefit]",
    );
    this.continueBtn = this.querySelector("#cart-drawer-continue-btn");
    this.addonsDivider = this.querySelector(".cart-drawer-divider");

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.close());
    });

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    this.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") this.close();
    });

    if (this.continueBtn) {
      this.continueBtn.addEventListener(
        "click",
        this.handleContinueClick.bind(this),
      );
    }

    // Handle flyover open/close
    this.addEventListener("click", (event) => {
      const openBtn = event.target.closest(".js-open-flyover");
      if (openBtn) {
        const wrapper = openBtn.closest(".cart-addons-flyover-wrapper");
        if (wrapper) {
          const flyover = wrapper.querySelector(".cart-addons-flyover");
          if (flyover) flyover.classList.add("is-open");
        }
      }

      const backBtn = event.target.closest(".js-back-flyover");
      if (backBtn) {
        const flyover = backBtn.closest(".cart-addons-flyover");
        if (flyover) flyover.classList.remove("is-open");
      }

      const closeBtn = event.target.closest(".js-close-flyover");
      if (closeBtn) {
        const flyover = closeBtn.closest(".cart-addons-flyover");
        if (flyover) flyover.classList.remove("is-open");
        this.close();
      }
    });
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "product-form") {
          this.renderContents(event.cartData);
        }
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  // --- Helper functions required by your product-form.js ---
  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  handleContinueClick(e) {
    e.preventDefault();

    // Trigger slide-over transition immediately
    this.classList.add('show-services-view');

    const allInputs = Array.from(
      this.querySelectorAll("#cart-drawer-addons-list input[type='checkbox']"),
    );
    const inputsToAdd = allInputs.filter(
      (input) => input.checked && input.dataset.inCart !== "true",
    );
    const inputsToRemove = allInputs.filter(
      (input) => !input.checked && input.dataset.inCart === "true",
    );

    if (
      (inputsToAdd.length === 0 && inputsToRemove.length === 0) ||
      !this.currentItem
    ) {
      this.populateServicesView(allInputs.filter(input => input.checked));
      return;
    }

    this.continueBtn.classList.add("loading");
    this.continueBtn.innerHTML = "Updating...";

      // Add temporary loading indicator to the added services list
      const servicesAddedLists = this.querySelectorAll(".cart-drawer-added-services-list");
      servicesAddedLists.forEach(list => {
        const existingDynamic = list.querySelectorAll('.is-dynamic');
        existingDynamic.forEach(el => el.remove());
        
        list.insertAdjacentHTML(
          'beforeend', 
          `<li class="cart-benefit is-dynamic cart-drawer-updating-message">
            <span class="cart-benefit__icon" aria-hidden="true" style="display: flex; align-items: center;">
              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg" style="width: 14px; height: 14px;"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
            </span>
            <span class="cart-benefit__copy">Updating cart...</span>
          </li>`
        );
      });

    let updatePromise = Promise.resolve();

    if (inputsToRemove.length > 0) {
      const updates = {};
      inputsToRemove.forEach((input) => {
        if (input.dataset.cartKey) {
          updates[input.dataset.cartKey] = 0;
        }
      });
      updatePromise = fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    }

    const itemsToAdd = inputsToAdd.map((input) => {
      const properties = {
        type: "addon",
        _product_type:
          input.dataset.productType ||
          this.currentItem.properties?._product_type ||
          "",
        _for_product: this.currentItem.id.toString(), // Links the addon back to the main item
      };

      if (input.dataset.addonType === "warranty" && input.dataset.barcode) {
        properties.__covered_barcode = input.dataset.barcode;
      }

      return {
        id: parseInt(input.value, 10),
        quantity: 1,
        properties,
      };
    });

    updatePromise
      .then(() => {
        if (itemsToAdd.length > 0) {
          return fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: itemsToAdd }),
          });
        }
      })
      .then((response) => {
        if (response) return response.json();
      })
      .then((data) => {
        this.continueBtn.classList.remove("loading");
        this.continueBtn.innerHTML = "Continue";
        // Update data-in-cart so consecutive clicks don't re-add
        inputsToAdd.forEach(input => input.dataset.inCart = "true");
        inputsToRemove.forEach(input => input.dataset.inCart = "false");

        // Populate the Services Added view
        this.populateServicesView(allInputs.filter(input => input.checked));
      })
      .catch((error) => {
        console.error("Error updating cart:", error);
        this.continueBtn.classList.remove("loading");
        this.continueBtn.innerHTML = "Continue";
        const servicesContent = this.querySelector('.cart-drawer-added-services-list');
        if (servicesContent) {
          servicesContent.innerHTML = '<span class="cart-drawer-services-list__empty" style="color: red;">Error updating services. Please try again.</span>';
        }
        this.querySelectorAll('.cart-drawer-updating-message').forEach(el => el.remove());
      });
  }

  populateServicesView(checkedInputs) {
    const servicesAddedLists = this.querySelectorAll(".cart-drawer-added-services-list");
    if (!servicesAddedLists.length) return;

    const template = document.getElementById('cart-drawer-service-item-template');
    if (!template) return;

    servicesAddedLists.forEach(servicesAddedList => {
      // Clear existing dynamic services to prevent duplicates
      const existingDynamic = servicesAddedList.querySelectorAll('.is-dynamic');
      existingDynamic.forEach(el => el.remove());

      checkedInputs.forEach(input => {
        const addonItem = input.closest('.addon-item');
        const title = addonItem ? addonItem.querySelector('.addon-item__title').textContent.trim() : 'Service';
        const price = addonItem ? addonItem.querySelector('.addon-item__price').textContent.trim() : '';
        
        const clone = template.content.cloneNode(true);
        const li = clone.querySelector('li');
        if (li) li.classList.add('is-dynamic');
        

        clone.querySelector('[data-title]').textContent = title;
        clone.querySelector('[data-price]').textContent = price;
        servicesAddedList.appendChild(clone);
      });
    });
  }
  // ---------------------------------------------------------

  open() {
    this.classList.remove("translate-x-full");
    this.classList.add("translate-x-0");

    if (this.overlay) {
      this.overlay.classList.remove("drawer-hidden");
      setTimeout(() => {
        this.overlay.classList.remove("drawer-opacity-0");
        this.overlay.classList.add("drawer-opacity-100");
      }, 10);
    }
    document.body.classList.add("cart-drawer-open");
  }

  close() {
    this.classList.remove("translate-x-0");
    this.classList.add("translate-x-full");

    const cleanup = () => {
      // Snap drawer back to Screen 1
      this.classList.remove('show-services-view');
      // Prune dynamic items out of the list so they don't persist
      const dynamicServices = this.querySelectorAll('.cart-drawer-added-services-list .is-dynamic');
      dynamicServices.forEach(service => service.remove());

      // Reset scroll position
      this.querySelectorAll('.cart-drawer__view').forEach(view => {
        view.scrollTop = 0;
      });

      // Close any open flyovers when the main drawer gets closed
      this.querySelectorAll(".cart-addons-flyover").forEach(flyover => flyover.classList.remove("is-open"));
    };

    if (this.overlay) {
      this.overlay.classList.remove("drawer-opacity-100");
      this.overlay.classList.add("drawer-opacity-0");
      setTimeout(() => {
        this.overlay.classList.add("drawer-hidden");
        cleanup();
      }, 300);
    } else {
      setTimeout(cleanup, 300);
    }
    document.body.classList.remove("cart-drawer-open");
  }

  setHidden(element, hidden) {
    if (!element) return;

    element.classList.toggle("hidden", hidden);
  }

  clearBaseWarrantyBenefit() {
    if (!this.itemWarrantyBenefit) return;
    const existingBase = this.itemWarrantyBenefit.querySelector('.cart-benefit--warranty');
    if (existingBase) existingBase.remove();
  }

  removeDisabledAddonSections(
    sectionContent,
    { warrantyEnabled, servicesEnabled },
  ) {
    const enabledByGroup = { servicesEnabled, warrantyEnabled };
    const disabledTitles = CART_DRAWER_ADDON_GROUPS.flatMap(
      ({ enabledKey, group, legacyTitles }) => {
        if (enabledByGroup[enabledKey]) return [];

        const selector = `[data-cart-drawer-addon-group="${group}"]`;
        sectionContent
          .querySelectorAll(selector)
          .forEach((element) => element.remove());

        return legacyTitles;
      },
    );

    if (disabledTitles.length === 0) return;

    sectionContent
      .querySelectorAll(CART_DRAWER_ADDON_TITLE_SELECTOR)
      .forEach((titleElement) => {
        if (disabledTitles.includes(titleElement.textContent.trim())) {
          removeDrawerAddonHeaderSection(titleElement);
        }
      });
  }
  getMoneyValue(value) {
    if (value === undefined || value === null || value === "") return null;

    const cents = Number(value);
    return Number.isFinite(cents) ? cents : null;
  }

  escapeHtml(value) {
    const element = document.createElement("span");
    element.textContent = value;
    return element.innerHTML;
  }

  getDiscountBadgeTitles(item, cart = null) {
    const titles = [];

    const addTitle = (title) => {
      const normalizedTitle = String(title || "").trim();
      if (!normalizedTitle || titles.includes(normalizedTitle)) return;

      titles.push(normalizedTitle);
    };

    const lineDiscounts = [
      ...(item?.line_level_discount_allocations || []),
      ...(item?.discount_allocations || []),
      ...(item?.discounts || []),
    ];

    lineDiscounts.forEach((discount) => {
      addTitle(
        discount.discount_application?.title ||
          discount.discount_application_title ||
          discount.title,
      );
    });

    if (titles.length === 0) {
      (cart?.cart_level_discount_applications || []).forEach((discount) => {
        addTitle(discount.title);
      });
    }

    return titles.slice(0, CART_DRAWER_MAX_DISCOUNT_BADGES);
  }

  shouldOverrideDiscountBadge(title) {
    if (!this.discountBadgeMatchText) return false;

    return String(title || "")
      .trim()
      .toLowerCase()
      .includes(this.discountBadgeMatchText);
  }

  getDiscountBadgeIconTemplate(shouldOverrideBadge) {
    if (shouldOverrideBadge && this.discountBadgeOverrideIconTemplate) {
      return this.discountBadgeOverrideIconTemplate;
    }

    return this.discountBadgeDefaultIconTemplate;
  }

  appendDiscountBadgeContent(badge, title, iconTemplate) {
    if (!iconTemplate) {
      badge.textContent = title;
      return;
    }

    badge.append(
      iconTemplate.content.cloneNode(true),
      document.createTextNode(title),
    );
  }

  renderDiscountBadges(item, cart = null) {
    if (!this.itemDiscountBadges) return;

    const badges = this.getDiscountBadgeTitles(item, cart).map((title) => {
      const shouldOverrideBadge = this.shouldOverrideDiscountBadge(title);
      const iconTemplate =
        this.getDiscountBadgeIconTemplate(shouldOverrideBadge);
      const badge = document.createElement("div");
      badge.className = CART_DRAWER_DISCOUNT_BADGE_CLASS;

      badge.classList.add(CART_DRAWER_STYLED_DISCOUNT_BADGE_CLASS);
      if (shouldOverrideBadge) {
        badge.classList.add(CART_DRAWER_OVERRIDE_DISCOUNT_BADGE_CLASS);
      }

      this.appendDiscountBadgeContent(badge, title, iconTemplate);
      return badge;
    });

    this.itemDiscountBadges.replaceChildren(...badges);
    this.setHidden(this.itemDiscountBadges, badges.length === 0);
  }

  getCartLinePricing(item) {
    const quantity = Number.parseInt(item.quantity, 10);
    const safeQuantity =
      Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    const unitPrice = this.getMoneyValue(
      item.final_price ?? item.discounted_price ?? item.price,
    );
    const originalUnitPrice = this.getMoneyValue(
      item.original_price ?? item.price,
    );
    const current =
      this.getMoneyValue(item.final_line_price) ??
      (unitPrice !== null ? unitPrice * safeQuantity : null) ??
      this.getMoneyValue(item.line_price);
    const original =
      this.getMoneyValue(item.original_line_price) ??
      (originalUnitPrice !== null ? originalUnitPrice * safeQuantity : null);
    const compareAt = this.getMoneyValue(item.compare_at_price);

    return {
      quantity: safeQuantity,
      current,
      original,
      retail: compareAt !== null ? compareAt * safeQuantity : original,
      isDiscounted: current !== null && original !== null && current < original,
    };
  }

  renderLinePricing(pricing, retailOverride = null) {
    if (!this.itemPrice) return;

    this.itemPrice.classList.toggle(
      "cart-line-price__current--discounted",
      pricing.isDiscounted,
    );

    if (pricing.current === null) {
      this.itemPrice.innerHTML =
        '<span class="cart-line-price__amount"></span>';
      this.setHidden(this.itemPrice, true);
      this.setHidden(this.itemCompareAtPrice?.parentElement, true);
      this.setHidden(this.itemSave?.parentElement, true);
      return;
    }

    const discountLabel = this.itemPrice.dataset.discountLabel;
    const nowMarkup =
      pricing.isDiscounted && discountLabel
        ? `<span class="cart-line-price__now">${this.escapeHtml(
            discountLabel,
          )}</span>`
        : "";
    this.itemPrice.innerHTML = `${nowMarkup}<span class="cart-line-price__amount">${this.formatMoney(
      pricing.current,
    )}</span>`;
    this.setHidden(this.itemPrice, false);

    const retail =
      this.getMoneyValue(retailOverride) ?? this.getMoneyValue(pricing.retail);
    const hasSavings = retail !== null && retail > pricing.current;

    this.setHidden(this.itemCompareAtPrice?.parentElement, !hasSavings);
    this.setHidden(this.itemSave?.parentElement, !hasSavings);

    if (!hasSavings) return;

    if (this.itemCompareAtPrice) {
      this.itemCompareAtPrice.textContent = this.formatMoney(retail);
    }

    if (this.itemSave) {
      this.itemSave.textContent = this.formatMoney(retail - pricing.current);
    }
  }

  getMatchingCartItem(cart, item) {
    if (!cart?.items?.length) return null;

    if (item.key) {
      const matchedByKey = cart.items.find(
        (cartItem) => cartItem.key === item.key,
      );
      if (matchedByKey) return matchedByKey;
    }

    const itemVariantId = String(item.variant_id ?? item.id ?? "");
    if (!itemVariantId) return null;

    return cart.items.find((cartItem) => {
      const cartItemVariantId = String(
        cartItem.variant_id ?? cartItem.id ?? "",
      );
      return cartItemVariantId === itemVariantId;
    });
  }

  renderCartLinePricingFromCart(item, cart, retailOverride = null) {
    const cartItem = this.getMatchingCartItem(cart, item);
    if (!cartItem) return false;

    this.renderDiscountBadges(cartItem, cart);
    this.renderLinePricing(this.getCartLinePricing(cartItem), retailOverride);
    return true;
  }

  refreshLinePricing(item, retailOverride = null, cartData = null) {
    if (
      cartData?.items &&
      this.renderCartLinePricingFromCart(item, cartData, retailOverride)
    ) {
      return;
    }

    fetch(`${window.Shopify.routes.root}cart.js`, {
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((cart) => {
        this.renderCartLinePricingFromCart(item, cart, retailOverride);
      })
      .catch((error) => {
        console.error("Error refreshing cart drawer price:", error);
      });
  }

  renderContents(cartData) {
    const item = cartData.items ? cartData.items[0] : cartData;
    if (!item) return;

    this.currentItem = item;

    const pricing = this.getCartLinePricing(item);
    this.renderDiscountBadges(item, cartData);
    this.renderLinePricing(pricing);

    if (this.itemShippingMessage) {
      this.itemShippingMessage.innerHTML = "";
      this.itemShippingMessage.classList.add("hidden");
    }

    if (this.itemWarrantyBenefit) {
      // Only clear the base warranty, keep dynamic services intact
      this.clearBaseWarrantyBenefit();
    }

    if (item.handle && item.variant_id) {
      // Fetch a custom section to access Shopify Liquid Metafields
      fetch(
        `/products/${item.handle}?variant=${item.variant_id}&section_id=variant-metafield-data`,
      )
        .then((response) => response.text())
        .then((text) => {
          // Parse the returned HTML to extract the data attribute
          const html = new DOMParser().parseFromString(text, "text/html");
          const dataElement = html.querySelector("[data-variant-metafields]");
          const shippingElement = html.querySelector(
            "[data-cart-drawer-shipping-message]",
          );
          const benefitsElement = html.querySelector(
            "[data-cart-drawer-benefits-message]",
          );

          if (dataElement) {
            const conditionDetailed = dataElement.dataset.conditionDetailed;
            const compareAtPrice = dataElement.dataset.compareAtPrice
              ? Number(dataElement.dataset.compareAtPrice) * pricing.quantity
              : null;

            // Update the variant text once the async fetch is complete
            if (conditionDetailed && this.itemVariantText) {
              this.itemVariantText.textContent = conditionDetailed;
            }

            // Re-evaluate compare at price once the async fetch is complete
            this.refreshLinePricing(item, compareAtPrice, cartData);
          }

          if (shippingElement && this.itemShippingMessage) {
            this.itemShippingMessage.innerHTML =
              shippingElement.innerHTML.trim();
            this.itemShippingMessage.classList.toggle(
              "hidden",
              !this.itemShippingMessage.innerHTML,
            );
          }

          if (benefitsElement && this.itemWarrantyBenefit) {
            // Prevent overwriting the dynamically added services
            this.clearBaseWarrantyBenefit();
            
            this.itemWarrantyBenefit.insertAdjacentHTML('afterbegin', benefitsElement.innerHTML.trim());
          }
        })
        .catch((error) => {
          console.error("Error fetching metafield data:", error);
        });
    }

    if (item.image) {
      this.itemImage.src = item.image;
      this.itemImage.alt = item.product_title || item.title;
      this.setHidden(this.itemImage, false);
    } else {
      this.setHidden(this.itemImage, true);
    }

    this.itemTitle.textContent = item.product_title || item.title;

    if (item.variant_title && item.variant_title !== "Default Title") {
      this.itemVariantText.textContent = item.variant_title; // Fallback text while loading
      this.setHidden(this.itemVariantWrapper, false);
    } else {
      this.setHidden(this.itemVariantWrapper, true);
    }

    this.setHidden(this.itemWrapper, false);

    const addonsList = this.querySelector("#cart-drawer-addons-list");
    const drawerAddonsWarrantyOn = this.dataset.drawerAddonsWarranty === "true";
    const drawerAddonsServicesOn = this.dataset.drawerAddonsServices === "true";
    const drawerAddonsOn = drawerAddonsWarrantyOn || drawerAddonsServicesOn;

    if (!drawerAddonsOn) {
      if (addonsList) {
        addonsList.innerHTML = "";
        this.setHidden(addonsList, true);
      }
      this.setHidden(this.addonsDivider, true);
    } else {
      this.setHidden(this.addonsDivider, false);
      if (addonsList && item.handle && item.variant_id) {
        addonsList.innerHTML = "";
        this.setHidden(addonsList, true);

        const sectionUrl = new URL(
          `/products/${item.handle}`,
          window.location.origin,
        );
        sectionUrl.searchParams.set("variant", item.variant_id);
        sectionUrl.searchParams.set("section_id", "cart-drawer-addons");
        sectionUrl.searchParams.set(
          "drawer_addons_warranty",
          drawerAddonsWarrantyOn ? "true" : "false",
        );
        sectionUrl.searchParams.set(
          "drawer_addons_services",
          drawerAddonsServicesOn ? "true" : "false",
        );

        fetch(`${sectionUrl.pathname}${sectionUrl.search}`)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, "text/html");
            const sectionContent = html.querySelector(".shopify-section");
            if (sectionContent) {
              this.removeDisabledAddonSections(sectionContent, {
                warrantyEnabled: drawerAddonsWarrantyOn,
                servicesEnabled: drawerAddonsServicesOn,
              });

              const content = sectionContent.innerHTML.trim();
              if (content === "") {
                addonsList.innerHTML = "";
                this.setHidden(addonsList, true);
                this.setHidden(this.addonsDivider, true);
              } else {
                addonsList.innerHTML = content;
                this.setHidden(addonsList, false);
                this.setHidden(this.addonsDivider, false);
              }
            }
          })
          .catch((error) => {
            console.error("Error fetching addons:", error);
            addonsList.innerHTML = "";
            this.setHidden(addonsList, true);
            this.setHidden(this.addonsDivider, true);
          });
      } else {
        this.setHidden(addonsList, true);
        this.setHidden(this.addonsDivider, true);
      }
    }

    this.open();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat("en-CA", {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 2,
    }).format(cents / 100);
  }
}

if (!customElements.get("cart-drawer")) {
  customElements.define("cart-drawer", CustomCartDrawer);
}

document.addEventListener("change", (event) => {
  const checkbox = event.target.closest('[data-addon-group="warranty"]');

  if (!checkbox || !checkbox.checked) return;

  document
    .querySelectorAll('#cart-drawer-addons-list [data-addon-group="warranty"]')
    .forEach((item) => {
      if (item !== checkbox) item.checked = false;
    });
});
